import React, { useRef, useState } from "react";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const NavigationNewsletter = ({ color = "blue", location, onSuccess, withBg = false }) => {

    const currentPath = location?.pathname || (typeof window !== 'undefined' ? window.location.pathname : '');
    const isEnglish = currentPath?.includes('/en');

    function handleChange(e) {
        value[e.target.id] = e.target.value;
        setValue({ ...value })
        if (document.querySelector('#emailmenu')) {
            document.querySelector('#emailmenu').style.borderColor = 'var(--dark-color)';
        }
        setStatus('idle');
        setFinished(false);
    }

    const [value, setValue] = React.useState({})
    const [status, setStatus] = useState('idle');

    const menuNewsletterInput = useRef();
    const [hasFocus, setFocus] = useState(false);
    const [isFinished, setFinished] = useState(false);

    const [isTeacher, setIsTeacher] = useState(false);

    async function onSubmit(e) {
        e.preventDefault()
        const email = value.emailmenu?.trim();

        if (!email) {
            if (document.querySelector('#emailmenu')) {
                document.querySelector('#emailmenu').style.borderColor = '#F05353';
            }
            return;
        }

        if (!EMAIL_REGEX.test(email)) {
            if (document.querySelector('#emailmenu')) {
                document.querySelector('#emailmenu').style.borderColor = '#F05353';
            }
            return;
        }

        setStatus('loading');
        setFinished(false);

        try {
            const response = await fetch('/.netlify/functions/newsletter', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    isTeacher: isTeacher,
                }),
            });

            // Check if response is ok and has content
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            // Get response text first to check if it's empty
            const responseText = await response.text();

            if (!responseText) {
                throw new Error('Empty response from server');
            }

            let result;
            try {
                result = JSON.parse(responseText);
            } catch (parseError) {
                console.error('Failed to parse JSON response:', parseError);
                throw new Error('Invalid response from server');
            }

            if (result.success) {
                setStatus('success');
                setFinished(true);
                setValue({});
                setIsTeacher(false);
                if (typeof onSuccess === 'function') {
                    onSuccess();
                }
                if (document.querySelector('#emailmenu')) {
                    document.querySelector('#emailmenu').style.borderColor = 'var(--dark-color)';
                }
            } else {
                setStatus('error');
                if (document.querySelector('#emailmenu')) {
                    document.querySelector('#emailmenu').style.borderColor = '#F05353';
                }
            }
        } catch (error) {
            console.error('Newsletter subscription error:', error);
            setStatus('error');
            if (document.querySelector('#emailmenu')) {
                document.querySelector('#emailmenu').style.borderColor = '#F05353';
            }
        }
    }

    const placeholderText = hasFocus
        ? (isEnglish ? "enter@email.here" : "email@hier.eingeben")
        : isFinished
            ? (isEnglish ? "Added!" : "Hinzugefügt!")
            : status === 'loading'
                ? (isEnglish ? "Sending..." : "Wird gesendet...")
                : (isEnglish ? "Newsletter" : "Newsletter");

    return <><form onSubmit={onSubmit} method="post" className={"popin-reveal"}>
        <div className={`${color === 'green' ? 'bg-red' : 'bg-[#3AB4CF]'} pr-2 flex items-center z-10  ${withBg ? 'w-full phonexl:w-fit mx-auto' : ''}`}>
            <input
                className={hasFocus ? `focused ${color === 'green' ? 'bg-red' : 'bg-[#3AB4CF]'} ${withBg ? 'w-full phonexl:w-fit' : ''} text-white py-1 placeholder-white victor text-2xl focus:outline-none px-2` : `${color === 'green' ? 'bg-red' : 'bg-[#3AB4CF]'} ${withBg ? 'w-full phonexl:w-fit' : ''} text-white py-1 px-2 placeholder-white victor text-2xl`}
                autoComplete="off"
                placeholder={placeholderText}
                ref={menuNewsletterInput}
                onFocus={() => { setFocus(true); setFinished(false); setStatus('idle'); }}
                onBlur={() => setFocus(false)}
                type="email"
                name="EMAIL"
                id={"emailmenu"}
                value={value.emailmenu ?? ''}
                onChange={handleChange}
                disabled={status === 'loading'}
            />
            <button type="submit" value="" name="subscribe" id="mc-embedded-subscribe" className="" disabled={status === 'loading'}>
                <svg xmlns="http://www.w3.org/2000/svg" width="13.398" height="10.449" viewBox="0 0 13.398 10.449">
                    <g id="Group_49" className={"stroke-white fill-none stroke-2"} data-name="Group 49" transform="translate(-668.193 1078.47) rotate(-90)">
                        <path id="Path_82" data-name="Path 82" d="M-852.781,666.193v10.725" transform="translate(1926.027 2)" />
                        <path id="Path_84" data-name="Path 84" d="M-857.731,675.45l4.517,4.517,4.517-4.517" transform="translate(1926.459 0.21)" />
                    </g>
                </svg>
            </button>
        </div>
        <label className={`flex items-center gap-2 text-sm text-center justify-center mt-1 ${withBg ? 'bg-red w-fit mx-auto px-2 py-2 text-white ' : ''}`}>
            <input
                type="checkbox"
                checked={isTeacher}
                onChange={() => setIsTeacher((prev) => !prev)}
                className="h-3 w-3 rounded border border-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black"
                disabled={status === 'loading'}
            />
            <span>{isEnglish ? "Sign up as teacher" : "als Lehrer*In anmelden"}</span>
        </label>
    </form>
    </>

}
export default NavigationNewsletter;
